import { render, staticRenderFns } from "./IconCompany.vue?vue&type=template&id=39e591e3"
import script from "./IconCompany.vue?vue&type=script&lang=js"
export * from "./IconCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports